module.exports = __webpack_public_path__ + "img/2020_12_29_cactus.6b7a50da.jpg";